import { render, staticRenderFns } from "./EligibilityDocuments.vue?vue&type=template&id=134da948&"
import script from "./EligibilityDocuments.vue?vue&type=script&lang=js&"
export * from "./EligibilityDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports